import { ageInDays } from './format';

/**
 * Age-colour thresholds for open inquiries (issue #23).
 * fresh < WARN, warn ≤ … ≤ HOT, hot > HOT days.
 * Kept as exported constants so thresholds can move into Settings later
 * without touching call sites.
 */
export const AGE_WARN_DAYS = 2;
export const AGE_HOT_DAYS = 4;

export type AgeTone = 'fresh' | 'warn' | 'hot';

/** Colour tone of an open inquiry by its age in whole days. */
export function ageTone(iso: string): AgeTone {
  const days = ageInDays(iso);
  if (days < AGE_WARN_DAYS) return 'fresh';
  if (days <= AGE_HOT_DAYS) return 'warn';
  return 'hot';
}
